"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _useFocusOn = _interopRequireDefault(require("web/shared/hooks/useFocusOn"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _useHoverNudge = _interopRequireDefault(require("web/shared/icons/useHoverNudge"));
var _InternalPageHeader = require("web/shared/components/InternalPageHeader.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The one-line heading every internal page shares: a way back, what this page
* is, and what it is currently looking at.
*
*     ←  Title  │  Viewing what the page is looking at        trailing
*
* One row, because on these pages every row above the content is a row the
* content never gets back — several of them scroll away nothing, since the
* region below is what scrolls.
*
* The arrow stands alone rather than spelling out where it goes. A row of
* chrome is read once and then recognized by shape, and a "Back to …" label
* costs a third of the line to say what the arrow already says.
*
* Centered rather than baseline-aligned: the heading is twice the size of the
* text beside it, so a shared baseline leaves the small parts hanging at the
* bottom of the row. The row states the alignment once and no child carries
* an offset of its own.
*/
function InternalPageHeader(props) {
  const navigate = (0, _reactRouterDom.useNavigate)();
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pointed = _useState2[0],
    setPointed = _useState2[1];
  const progress = (0, _useHoverNudge.default)(pointed);
  const backTo = props.backTo,
    backLabel = props.backLabel,
    title = props.title; // Focus follows the name, so reaching a page — by a link in a sidebar as
  // much as by a full load — is announced as the page it is.
  const headingRef = (0, _useFocusOn.default)(title);
  const goBack = () => {
    if (backTo == null) {
      return;
    }
    if (typeof backTo === "string") {
      navigate(backTo);
      return;
    }
    backTo();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_InternalPageHeader.styles.header)), {}, {
    children: [backTo == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      type: "button",
      "aria-label": backLabel !== null && backLabel !== void 0 ? backLabel : undefined,
      title: backLabel !== null && backLabel !== void 0 ? backLabel : undefined,
      onClick: goBack,
      onMouseEnter: () => setPointed(true),
      onMouseLeave: () => setPointed(false),
      onFocus: () => setPointed(true),
      onBlur: () => setPointed(false)
    }, stylex.props(_InternalPageHeader.styles.backArrow)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        name: "arrow-left",
        size: "s",
        progress: progress
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      ref: headingRef,
      tabIndex: -1
    }, stylex.props(_InternalPageHeader.styles.title)), {}, {
      children: title
    })), props.context == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)({}, stylex.props(_InternalPageHeader.styles.divider))), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_InternalPageHeader.styles.note)), {}, {
        children: props.context
      }))]
    }), props.trailing]
  }));
}
var _default = exports.default = InternalPageHeader;